export default __webpack_public_path__ + "static/media/bg+.bbe8a49d.png";